import whisperNudgeTracking from 'whisper-nudge-tracking';
import whisperSkymapTracking from 'whisper-skymap-tracking';

/**
 * Defines the structure for a Whisper module, including its name, loader function,
 * and whether it requires authentication.
 */

/**
 * Base modules that register their APIs directly on the Whisper object.
 * These modules are loaded synchronously and initialized first, before
 * any dependent modules. Currently includes tracking modules but may
 * include other core features in the future.
 */
export const BaseWhisperModules = [{
  name: 'NudgeTracking',
  loader: () => Promise.resolve({
    default: whisperNudgeTracking
  }),
  auth: 'app'
}, {
  name: 'SkymapTracking',
  loader: () => Promise.resolve({
    default: whisperSkymapTracking
  }),
  auth: 'none'
}];

/**
 * Modules that require the Whisper API to be available in the window object.
 * These are initialized after the core Whisper API is exposed.
 */
export const WhisperDependentModules = [{
  name: 'CentralEngagementOrchestrator',
  loader: () => import( /* webpackChunkName: "central-engagement-orchestrator" */
  'central-engagement-orchestrator').then(({
    initialize
  }) => void initialize()),
  auth: 'app',
  shouldLoadModule: () => {
    const isInIframe = window !== window.top;
    return !isInIframe;
  }
}];